import React from 'react';
import ListActions from './ListActions'
import {
	List,
	Responsive,
	SimpleList,
	Datagrid,
	TextField,
	NumberField,
} from 'admin-on-rest'
import { DealershipYearMonthFilters } from './Filters'

const rowStyle = (record, index) => ({
	fontWeight: record.is_total ? 'bold' : 'normal',
	backgroundColor: record.is_total ? '#fafafa' : '',
});


export const CCOfficerIncentive = (props) => (
    <List {...props}
		title="C&C Officer Incentive"
		filters={<DealershipYearMonthFilters />}
		actions={<ListActions refreshInterval="900000" />}
		>
		<Responsive
            // small={
            //     <SimpleList
            //         primaryText={record => record.cs_num}
            //     />
            // }
            large={
				<Datagrid rowStyle={rowStyle}>
					<TextField source="name" label="" sortable={false} />
					<NumberField source="num_accounts" label="# Accounts" sortable={false} />
					<NumberField source="incentive_per_account" label="Incentive per Account" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} sortable={false} />
					<NumberField source="total_incentive" label="Total Incentive" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} sortable={false} />
					<NumberField source="withholding_tax" label="Withholding Tax" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} sortable={false} />
					<NumberField source="net_incentive" label="Net Incentive" options={{ maximumFractionDigits: 2, style: 'currency', currency: 'PHP' }} sortable={false} />
		        </Datagrid>
            }
        />
    </List>
)



// WEBPACK FOOTER //
// ./src/reports/CCOfficerIncentive.js